import React from 'react';
import { InstagramIcon, MessageCircleIcon, FacebookIcon, PhoneIcon, GlobeIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { business } from '../data/business';
import { membershipCopy } from '../data/membership';
export function Footer() {
  const {
    t,
    lang,
    toggle
  } = useLanguage();
  const links = [{
    href: '#home',
    label: t.nav.home
  }, {
    href: '#services',
    label: t.nav.services
  }, {
    href: '#membership',
    label: membershipCopy[lang].kicker
  }, {
    href: '#gallery',
    label: t.nav.gallery
  }, {
    href: '#about',
    label: t.nav.about
  }, {
    href: '#faq',
    label: t.nav.faq
  }, {
    href: '#contact',
    label: t.nav.contact
  }];
  return <footer className="bg-navy text-white" data-id="element-133" data-mp="3qcx8kbgauo39">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 md:grid-cols-2 lg:grid-cols-4 lg:px-8" data-id="element-134" data-mp="3qblxdqkiye24">
        <div data-id="element-135" data-mp="2a19uvpu8vuyv">
          <p className="font-display text-xl font-extrabold tracking-tight" data-id="element-136" data-mp="2ey9yzv7jannc">
            los <span className="text-brand-orange" data-id="element-137" data-mp="2ew70snw89o7j">BROTHERS</span>
          </p>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-white/65" data-id="element-138" data-mp="3la29euiur3v8">{t.footer.about}</p>
          <div className="mt-5 flex gap-3" data-id="element-139" data-mp="3gc0g7grppo61">
            <a href={business.instagramHref} target="_blank" rel="noreferrer" aria-label="Instagram" className="flex h-9 w-9 items-center justify-center rounded-lg border border-white/20 transition-colors duration-150 hover:border-brand-cyan hover:text-brand-cyan" data-id="element-140" data-mp="3v7q6hr3xkngk">
              <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-141" data-mp="335pv8c173c9" />
            </a>
            <a href={business.whatsappHref} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="flex h-9 w-9 items-center justify-center rounded-lg border border-white/20 transition-colors duration-150 hover:border-brand-cyan hover:text-brand-cyan" data-id="element-142" data-mp="hrs8biwygb7p">
              <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-143" data-mp="mq3fflvv87m8" />
            </a>
            <a href={business.instagramHref} target="_blank" rel="noreferrer" aria-label="Facebook" className="flex h-9 w-9 items-center justify-center rounded-lg border border-white/20 transition-colors duration-150 hover:border-brand-cyan hover:text-brand-cyan" data-id="element-144" data-mp="tt090qdpumqh">
              <FacebookIcon className="h-4 w-4" aria-hidden="true" data-id="element-145" data-mp="1cmdwkaf3nqw2" />
            </a>
          </div>
        </div>

        <nav aria-label={t.footer.quickLinks} data-id="element-146" data-mp="1hjnw4iw7dixm">
          <h2 className="font-display text-sm font-bold uppercase tracking-wide text-white" data-id="element-147" data-mp="1hmife73hcxpg">
            {t.footer.quickLinks}
          </h2>
          <ul className="mt-4 space-y-2.5" data-id="element-148" data-mp="1rj4vkikv30l5">
            {links.map(link => <li key={link.href} data-id="element-149" data-mp="3oboltbvt3bfg">
                <a href={link.href} className="text-sm text-white/65 transition-colors duration-150 hover:text-brand-cyan" data-id="element-150" data-mp="3ocgfui9r913m">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div data-id="element-151" data-mp="25nc81wajts1e">
          <h2 className="font-display text-sm font-bold uppercase tracking-wide text-white" data-id="element-152" data-mp="25mu7ingusrno">
            {t.footer.servicesTitle}
          </h2>
          <ul className="mt-4 space-y-2.5" data-id="element-153" data-mp="1wnyzr6y5v9i9">
            {t.footer.services.map(service => <li key={service} data-id="element-154" data-mp="2tdzo54umbnz1">
                <a href="#services" className="text-sm text-white/65 transition-colors duration-150 hover:text-brand-cyan" data-id="element-155" data-mp="2tcy80lyqwbag">
                  {service}
                </a>
              </li>)}
          </ul>
        </div>

        <div data-id="element-156" data-mp="2feq8c6abqvvl">
          <h2 className="font-display text-sm font-bold uppercase tracking-wide text-white" data-id="element-157" data-mp="2fd5bub4g92v3">
            {t.footer.contactTitle}
          </h2>
          <ul className="mt-4 space-y-2.5 text-sm text-white/65" data-id="element-158" data-mp="18vrwdnu0q29c">
            <li data-id="element-159" data-mp="13y9u2gaialab">
              <a href={business.phoneHref} className="inline-flex items-center gap-2 transition-colors duration-150 hover:text-brand-cyan" data-id="element-160" data-mp="13xqeh68bw8zg">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-161" data-mp="2wo0t0itdf2bt" />
                {business.phoneDisplay}
              </a>
            </li>
            <li data-id="element-162" data-mp="2nu5qlijmvpzv">
              <a href={business.whatsappHref} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 transition-colors duration-150 hover:text-brand-cyan" data-id="element-163" data-mp="2ntmh8q81u9xg">
                <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-164" data-mp="3fj7p5noxh0s1" />
                WhatsApp
              </a>
            </li>
            <li data-id="element-165" data-mp="36kdpfogavua9">{t.footer.hours}</li>
            <li className="font-semibold text-brand-orange" data-id="element-166" data-mp="36jc8528oybk3">{t.footer.sameDay}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-167" data-mp="1q8govo4hza4e">
        <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-6 text-xs text-white/55 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8" data-id="element-168" data-mp="1v5qn9t9v6w4d">
          <p data-id="element-169" data-mp="1nnsfpub8tv3s">
            © {new Date().getFullYear()} los BROTHERS. {t.footer.rights}
          </p>
          <div className="flex flex-wrap items-center gap-5" data-id="element-170" data-mp="1ip7djpcfl1cp">
            <a href="#faq" className="transition-colors duration-150 hover:text-white" data-id="element-171" data-mp="1wlcg711a7ndc">
              {t.footer.privacy}
            </a>
            <a href="#faq" className="transition-colors duration-150 hover:text-white" data-id="element-172" data-mp="1rlq8f7482zbx">
              {t.footer.terms}
            </a>
            <button type="button" onClick={toggle} aria-label={t.nav.language} className="inline-flex items-center gap-1.5 rounded border border-white/20 px-2 py-1 font-bold uppercase transition-colors duration-150 hover:border-brand-cyan hover:text-brand-cyan" data-id="element-173" data-mp="zx68u6cz6gvd">
              <GlobeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-174" data-mp="l5waedr6oftj" />
              {lang === 'en' ? 'EN' : 'ES'}
            </button>
          </div>
        </div>
      </div>
    </footer>;
}